module.exports = __webpack_public_path__ + "img/cargo-wagon-door-vertical-side.95e19cc2.png";